import React from "react";
import styled from "styled-components";
import { useCartContext } from "../context/cart_context";
import { Link } from "react-router-dom";
import CartColumns from "./CartColumns";
import CartItem from "./CartItem";
import CartTotals from "./CartTotals";
import SendingForm from "./SendingForm";

const CartContent = () => {
  const { cart, clearCart } = useCartContext();
  // form lives in SendingForm, submit button in CartTotals — sending state is shared here
  const [isSending, setIsSending] = React.useState(false);
  return (
    <Wrapper className="section section-center">
      <div className="cart-card">
        <CartColumns />
        {cart.map((item) => (
          <CartItem key={item.id} {...item} />
        ))}
      </div>

      <div className="link-container">
        <Link to="/pronajem-party-stanu-vybaveni" className="ghost-link">
          ← pokračovat v nákupu
        </Link>
        <button
          type="button"
          className="clear-btn"
          onClick={clearCart}
        >
          Vyčistit košík
        </button>
      </div>

      <SendingForm cart={cart} onSendingChange={setIsSending} />
      <CartTotals isSending={isSending} />
    </Wrapper>
  );
};

const Wrapper = styled.section`
  .cart-card {
    background: var(--clr-paper);
    border: 1px solid var(--clr-divider);
    border-radius: var(--radius-lg);
    padding: 1.5rem;
    box-shadow: var(--shadow-sm);
  }

  .link-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
    margin-top: 1.5rem;
    margin-bottom: 1rem;
  }

  .ghost-link {
    background: transparent;
    border: none;
    color: var(--clr-charcoal-3);
    font-family: var(--ff-body);
    font-size: 0.95rem;
    padding: 0.6rem 0.6rem 0.6rem 0;
    cursor: pointer;
    transition: var(--transition);
    min-height: 44px;
    display: inline-flex;
    align-items: center;
  }
  .ghost-link:hover {
    color: var(--clr-accent-dark);
    transform: translateX(-2px);
  }

  .clear-btn {
    background: transparent;
    color: var(--clr-red-dark);
    border: 1px solid var(--clr-red-dark);
    padding: 0.6rem 1.25rem;
    border-radius: var(--radius-pill);
    cursor: pointer;
    font-family: var(--ff-body);
    font-weight: 500;
    font-size: 0.9rem;
    min-height: 44px;
    transition: var(--transition);
  }
  .clear-btn:hover {
    background: var(--clr-red-dark);
    color: var(--clr-paper);
  }
`;

export default CartContent;
